<h1 mat-dialog-title align="center">{{ data.title }}</h1>
<div mat-dialog-content>{{ data.content }}</div>
<div mat-dialog-actions align="center">
  <button
    mat-button
    mat-raised-button
    mat-dialog-close
    color="primary"
  >
    Aceptar
  </button>
</div>
